import {
  EngageCommunicationListItem,
  EngageFlatContact,
  EngageFlatListItem,
  EngageFlatsDefaultFilter,
  EngagePropertiesDefaultFilter,
  EngageStore,
  FlatContactType,
} from 'types/Engage';
import { PageEnum } from './types';
import { sortBy } from 'lodash';

export function getDefaultEngageData(): EngageStore {
  return {
    type: PageEnum.engage,
    data: {
      isWaitingInitLoad: true,
      isLoading: false,
      properties: {
        totalCount: 0,
        pageNumber: 1,
        dataOrder: [],
        data: {},
        filters: { ...EngagePropertiesDefaultFilter },
      },
      flats: {
        totalCount: 0,
        pageNumber: 1,
        dataOrder: [],
        data: {},
        filters: { ...EngageFlatsDefaultFilter },
      },
      flat: null,
    },
  };
}

export function getFormattedFlatName(name: string): string {
  if (name.includes('Flat ') || name.startsWith('flat ')) {
    return name;
  }
  return `Flat ${name}`;
}

export function sortContactsByType<
  T extends Pick<
    EngageFlatContact,
    'isOwner' | 'isResident' | 'isUnder16' | 'contactType'
  > & { firstName?: string; lastName?: string; name?: string },
>(contacts: T[]): T[] {
  return sortBy(
    contacts,
    (contact) =>
      (contact.isOwner
        ? !contact.isResident
          ? 1 // owner
          : 2 // owner & resident
        : contact.isResident
          ? !contact.isUnder16
            ? 3 // resident over 16
            : 4 // resident under 16
          : contact.contactType === FlatContactType.onBehalfOf
            ? 5
            : contact.contactType === FlatContactType.lettingAgent
              ? 6
              : 7) +
      (contact.name || `${contact.firstName} ${contact.lastName}`),
  );
}

export function sortCommunicationsByDateReversed(
  communications: EngageCommunicationListItem[],
): EngageCommunicationListItem[] {
  return sortBy(
    communications,
    (communication) => communication.createdDate,
  ).reverse();
}

export function flatContactToFlatListContact(
  contact: EngageFlatContact,
): EngageFlatListItem['contacts'][number] {
  return {
    id: contact.id,
    name: `${contact.firstName} ${contact.lastName || ''}`.trim(),
    isOwner: contact.isOwner,
    isResident: contact.isResident,
    isUnder16: contact.isUnder16,
    hasSupportNeeds: contact.hasSupportNeeds,
    contactType: contact.contactType,
    isConfirmed: contact.isConfirmed,
    confirmedDate: contact.confirmedDate,
  };
}
